module.exports = __webpack_public_path__ + "img/left-arrow-nav-bar.53fcc1a3.svg";